// IntegrationDetail "Coming Soon" stub. Re-exported as default by
// src/pages/integrations/IntegrationDetail.tsx for the /integrations/:key route.
import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { Plug } from 'lucide-react'

function ComingSoon({ title, icon: Icon, color, description }: { title: string; icon: React.ElementType; color: string; description: string }) {
  const navigate = useNavigate()
  return (
    <div style={{ padding: '28px 32px' }}>
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        style={{ maxWidth: 480, margin: '60px auto 0', textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: 18, background: `color-mix(in srgb, ${color} 8%, transparent)`, border: `1px solid color-mix(in srgb, ${color} 15%, transparent)`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', boxShadow: `0 0 32px color-mix(in srgb, ${color} 13%, transparent)` }}>
          <Icon style={{ width: 28, height: 28, color }} />
        </div>
        <h1 style={{ fontSize: 26, fontWeight: 900, color: 'var(--ink-primary)', letterSpacing: '-0.03em', margin: '0 0 10px' }}>{title}</h1>
        <p style={{ fontSize: 14, color: 'var(--ink-tertiary)', lineHeight: 1.6 }}>{description}</p>
        <div style={{ marginTop: 24, display: 'flex', gap: 10, justifyContent: 'center' }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: color, boxShadow: `0 0 8px ${color}` }} />
          <p style={{ fontSize: 12, color: 'var(--ink-tertiary)', margin: 0 }}>Being built right now</p>
        </div>
      </motion.div>
    </div>
  )
}

export function IntegrationDetail() {
  return <ComingSoon title="Integration Setup" icon={Plug} color="var(--info)" description="Connect and configure this integration." />
}
